/**
 * Move item from 1 pos to another
 * @param {Array<any>} arr
 * @param {number} fromIndex
 * @param {number} toIndex
 */
export const move = (arr, fromIndex, toIndex) => {
  const clonedArray = [...arr];
  const element = clonedArray[fromIndex];

  clonedArray.splice(fromIndex, 1);
  clonedArray.splice(toIndex, 0, element);

  return clonedArray;
};

export const trimObjectStrings = (obj) => {
  if (!obj || typeof obj !== "object") {
    throw new Error("Input must be an object.");
  }

  const trimStrings = (value) => {
    if (typeof value === "string") {
      return value.trim();
    } else if (Array.isArray(value)) {
      return value.map(trimStrings);
    } else if (value && typeof value === "object") {
      return trimObjectStrings(value);
    }
    return value;
  };

  return Object.keys(obj).reduce((result, key) => {
    result[key] = trimStrings(obj[key]);
    return result;
  }, {});
};
